/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchState } from './SearchState';
import {
    SearchStateFromJSON,
    SearchStateFromJSONTyped,
    SearchStateToJSON,
} from './SearchState';

/**
 * Representation of a Breadcrumb
 * @export
 * @interface Breadcrumb
 */
export interface Breadcrumb {
    /**
     * Code of the facet
     * @type {string}
     * @memberof Breadcrumb
     */
    facetCode?: string;
    /**
     * Name of the facet
     * @type {string}
     * @memberof Breadcrumb
     */
    facetName?: string;
    /**
     * Value code of the facet
     * @type {string}
     * @memberof Breadcrumb
     */
    facetValueCode?: string;
    /**
     * Value name of the facet
     * @type {string}
     * @memberof Breadcrumb
     */
    facetValueName?: string;
    /**
     * 
     * @type {SearchState}
     * @memberof Breadcrumb
     */
    removeQuery?: SearchState;
    /**
     * 
     * @type {SearchState}
     * @memberof Breadcrumb
     */
    truncateQuery?: SearchState;
}

/**
 * Check if a given object implements the Breadcrumb interface.
 */
export function instanceOfBreadcrumb(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BreadcrumbFromJSON(json: any): Breadcrumb {
    return BreadcrumbFromJSONTyped(json, false);
}

export function BreadcrumbFromJSONTyped(json: any, ignoreDiscriminator: boolean): Breadcrumb {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facetCode': !exists(json, 'facetCode') ? undefined : json['facetCode'],
        'facetName': !exists(json, 'facetName') ? undefined : json['facetName'],
        'facetValueCode': !exists(json, 'facetValueCode') ? undefined : json['facetValueCode'],
        'facetValueName': !exists(json, 'facetValueName') ? undefined : json['facetValueName'],
        'removeQuery': !exists(json, 'removeQuery') ? undefined : SearchStateFromJSON(json['removeQuery']),
        'truncateQuery': !exists(json, 'truncateQuery') ? undefined : SearchStateFromJSON(json['truncateQuery']),
    };
}

export function BreadcrumbToJSON(value?: Breadcrumb | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facetCode': value.facetCode,
        'facetName': value.facetName,
        'facetValueCode': value.facetValueCode,
        'facetValueName': value.facetValueName,
        'removeQuery': SearchStateToJSON(value.removeQuery),
        'truncateQuery': SearchStateToJSON(value.truncateQuery),
    };
}

